export default `
  query listBCObjects($workflowId: ID!, $boundedContextId: String!, $limit: Int, $nextToken: String) {
    listBCObjects(workflowId: $workflowId, boundedContextId: $boundedContextId, limit: $limit, nextToken: $nextToken) {
      items {
        id
        boundedContextId
        filepath
        prompt
        contents
        draftContents
        tags
      }
      nextToken
    }
  }
`
